import { H1 } from "@motley/design"
import Register from "./Register"
import SocialLogin from "./SocialLogin"
import { Link } from "@/base"

export default function GetStartedPage() {
  return (
    <div className="flex flex-col">
      <H1 className="text-center">Get Started</H1>
      <SocialLogin />
      <h4 className="p-4 text-center">– OR –</h4>
      <Register />
      <p className="pt-4 text-right">
        Already have an account?{" "}
        <Link to="/auth/login" search={{ email: undefined }}>
          Login
        </Link>
      </p>
    </div>
  )
}
